import { customElement, property } from "lit/decorators.js";
import { html, LitElement } from "lit";

@customElement("ehm-details-wrapper")
export class DetailsWrapper extends LitElement {
  @property()
  openText = "";

  @property()
  closeText = "";

  private detailsElement: HTMLDetailsElement | null = null;

  constructor() {
    super();
    this.detailsElement = this.querySelector("details");
  }

  connectedCallback() {
    super.connectedCallback();
    if (this.detailsElement) {
      this.detailsElement.addEventListener("toggle", this.handleToggle);
    }
  }

  handleToggle = (e: Event) => {
    const details = e.currentTarget as HTMLDetailsElement;
    const summary = details.querySelector("summary");
    if (!summary) return;
    if (details.open) {
      summary.querySelector("span")!.innerHTML = this.closeText;
    } else {
      summary.querySelector("span")!.innerHTML = this.openText;
    }
  };

  render() {
    return html`
      <slot></slot>
    `;
  }
}